import { render, staticRenderFns } from "./AdditionalServiceItemComponent.vue?vue&type=template&id=7f0ef92f"
import script from "./AdditionalServiceItemComponent.vue?vue&type=script&lang=js"
export * from "./AdditionalServiceItemComponent.vue?vue&type=script&lang=js"
import style0 from "./AdditionalServiceItemComponent.vue?vue&type=style&index=0&id=7f0ef92f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports